import {asset} from 'imba';
import url from './hospital_symbol.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.9639 3.98039C12.9182 3.98943 3.9712 12.9511 3.98025 23.9968C3.98929 35.0425 12.9509 43.9894 23.9966 43.9804C35.0423 43.9713 43.9893 35.0097 43.9802 23.964C43.9712 12.9183 35.0096 3.97134 23.9639 3.98039ZM19.9913 33.0475L19.9913 26.0475L27.9913 26.0475L27.9913 33.0475L31.9913 33.0475L31.9913 15.0475L27.9913 15.0475L27.9913 22.0475L19.9913 22.0475L19.9913 15.0475L15.9913 15.0475L15.9913 33.0475L19.9913 33.0475Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})